export default "__VITE_ASSET__CxkEvI4p__"